export enum SortOptions {
  ENTRIES_REMAINING = 'entriesRemaining',
  ENTRY_DEADLINE_DATE = 'startDate',
  ENTRY_FEE = 'entryFee',
  TOTAL_PRIZES = 'totalPrizes',
}
